<template>
    <v-popup :modelValue="modelValue" title="Использование Cookie" :closeOnOverlayClick="false" :closeOnEsc="false"
        width="500px">
        <div class="cookie-content">
            <p>
                Мы используем файлы cookie для улучшения работы сайта. Продолжая использовать сайт, вы соглашаетесь с
                нашей политикой использования файлов cookie. Если вы отклоните использование файлов cookie, некоторые
                функции сайта могут не работать корректно.
            </p>
            <span><a href="https://blco.pro/legal">Политика использования файлов cookie</a></span>
        </div>
        <template #footer>
            <default-button @click="reject" text="Отклонить" isSecondary></default-button>
            <default-button @click="accept" text="Принять"></default-button>

        </template>
    </v-popup>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'CookieConsentPopup',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue', 'accept'],
    methods: {
        accept() {
            localStorage.setItem('cookie_consent_accepted', 'true');
            this.$emit('update:modelValue', false);
            this.$emit('accept');
        },
        reject() {
            Cookies.remove('access_token')
            this.$router.push('/')
            this.$emit('update:modelValue', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.cookie-content {
    p {
        margin-bottom: 0;
        line-height: 1.5;
        color: var(--color-text);
    }
}
</style>
